import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const languageStorageKey = "lang";
const supportedLanguages = ["en", "ru"];

const getLanguageCode = (language: string) => {
  return language ? language.split("-")[0] : null;
};

const getInitialLanguage = () => {
  const browserLanguage = getLanguageCode(navigator.language || navigator.languages[0]);
  const params = new URLSearchParams(window.location.search);

  const siteLanguage = params.get("lang");

  if (siteLanguage && supportedLanguages.includes(siteLanguage)) {
    localStorage.setItem(languageStorageKey, siteLanguage);
    return siteLanguage;
  }

  const savedLanguage = localStorage.getItem(languageStorageKey);
  if (!savedLanguage) {
    localStorage.setItem(languageStorageKey, browserLanguage ?? "ru");
  }

  return savedLanguage ?? browserLanguage ?? "ru";
};

void i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: getInitialLanguage(),
    fallbackLng: "ru",
    backend: {
      loadPath: "/locales/{{lng}}.json",
    },
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on("languageChanged", (lng) => {
  localStorage.setItem(languageStorageKey, lng);
});

export const I18N_CONFIG = i18n;
